import { Box } from '@mui/material'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AdminCRMRoutes from './routes'

const MainFrame = () => (
  <Box
    sx={{
      flex: 1,
      minWidth: 0,
      px: { xs: 1.5, md: 3 },
      py: { xs: 2, md: 3 },
      boxSizing: 'border-box',
      overflowX: 'hidden',
    }}
  >
    <Box maxWidth={1500} marginX="auto">
      <Routes>
        <Route path="/*" element={<AdminCRMRoutes />} />
      </Routes>
    </Box>
  </Box>
)

export default MainFrame
